<template>
  <div id="login-parceiro">
    <div class="card card-login">
      <div class="loader"></div>
      <div class="d-flex justify-content-center">
        <div class="card-icon">
          <i class="icofont-user-alt-7"></i>
        </div>
      </div>
      <div id="form">
        <h2 class="card-title text-center">Demonstração</h2>
        <div class="row">
          <form @submit.prevent="login()">
            <pulse-loader
              :loading="loading"
              :color="color"
              :size="size"
              class="vue-loader"
            ></pulse-loader>
            <div class="col-12">
              <div class="form-group input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="icofont-lock"></i>
                  </span>
                </div>
                <select
                  class="form-control"
                  v-model="funcao"
                  name="funcao"
                  required
                >
                  <option value="" disabled selected>PERFIL</option>
                  <option
                    v-for="funcao in optionsFuncao"
                    :value="funcao"
                    :key="funcao.value"
                  >
                    {{ funcao.label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-12">
              <button type="submit" class="btn float-right">
                Entrar
                <b-spinner
                  label="Spinning"
                  small
                  variant="white"
                  v-if="loadingBtn"
                ></b-spinner>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import Municipio from '@/services/Municipio.js'
import Equipe from '@/services/Equipe.js'
import Profissional from '@/services/Profissional.js'
export default {
  components: {
    TheMask,
    PulseLoader,
  },
  name: 'Demonstracao',
  metaInfo: {
    title: 'Login - Demonstração ',
    titleTemplate: null,
    meta: [
      { charset: 'utf-8' },
      {
        name: 'description',
        content:
          'Um painel de gestão para ajudar profissionais de saúde e gestores no atendimento aos requisitos do financimento federal da APS.',
      },
    ],
  },
  data() {
    return {
      cpf: '',
      senha: '',
      cidade: '',
      cidades: [],
      no_municipio: '',
      mais_de_uma_cidade: false,
      id_funcao: '',
      value_selected_multiselect: [],
      cidades_select: [],
      cidades_selected: [],
      loading: false,
      size: '40px',
      color: '#0D98BB',
      verificandoUsuario: false,
      erroUsuario: false,
      btnLoginDisable: false,
      loadingBtn: false,
      funcao: '',

      optionsFuncao: [
        {
          value: 'secretario',
          cpf: '98781286015',
          senha: 'Teste@123',
          label: 'Secretário(a)',
          id_funcao: 1,
        },
        {
          value: 'administrador',
          cpf: '52348100037',
          senha: 'Teste@123',
          label: 'Administrador',
          id_funcao: 2,
        },
        {
          value: 'acs',
          cpf: '72274239053',
          senha: 'Teste@123',
          label: 'Agente Comunitário de Saúde (ACS)',
          id_funcao: 3,
        },
        {
          value: 'medico',
          cpf: '15636455135',
          senha: 'Teste@123',
          label: 'Médico(a)',
          id_funcao: 4,
        },
        {
          value: 'coordenador',
          cpf: '72274239053',
          senha: 'Teste@123',
          label: 'Gerente/Coordenador(a)',
          id_funcao: 7,
        },
        {
          value: 'enfermeiro',
          cpf: '67082783248',
          senha: 'Teste@123',
          label: 'Enfermeiro(a)',
          id_funcao: 4,
        },
        {
          value: 'odontologo',
          cpf: '00510771084',
          senha: 'Teste@123',
          label: 'Odontólogo(a)',
          id_funcao: 8,
        },
        {
          value: 'enfermagem',
          cpf: '63649239094',
          senha: 'Teste@123',
          label: 'Aux/Téc Enfermagem',
          id_funcao: 6,
        },
        {
          value: 'recepcionista',
          cpf: '03904207008',
          senha: 'Teste@123',
          label: 'Recepcionista',
          id_funcao: 5,
        },
      ],
    }
  },
  methods: {
    async login() {
      try {
        this.$store.state.demonstracao = true
        this.btnLoginDisable = true
        this.loadingBtn = true
        let url = '/web/login'
        const response = await this.$apiPublic.post(url, {
          cpf: this.funcao.cpf,
          senha: this.funcao.senha,
          cod_ibge: '1111111',
          id_funcao: this.funcao.id_funcao,
        })
        if (
          response.data.error == true &&
          response.data.message == 'USUÁRIO INATIVO!'
        ) {
          this.$router.push('/usuario-inativo')
          return
        }

        if (
          response.data.error == true &&
          response.data.message != 'USUÁRIO INATIVO!'
        ) {
          this.loading = false
          this.loadingBtn = false
          this.$toast.error(response.data.message, 'Error:', {
            position: 'topRight',
          })
        } else {
          let token = response.data.token
          this.$store.commit('updateAccessToken', token)

          // valida o usuário
          const response2 = await this.$api.post('/app/auth/token')

          //verifica se o município está ativo
          const statusMunicipio = await this.$apiPublic.get(
            '/faturamento/status/' + response2.data.cod_ibge
          )
          if (statusMunicipio.data.status == '0') {
            this.$router.push('/municipio-negado')
            return
          } else {
            // Verifica se o usuário tem permissões
            if (response2.data.permissoes == false) {
              this.$toast.error(
                'Usuário sem permissões! Entre em contato com o suporte.',
                'Error:',
                {
                  position: 'topRight',
                }
              )
              return false
            }

            // Busca a ultima atualização do município
            const ultimaAtualizacao = this.$store.state.ultimaAtualizacao
            if (ultimaAtualizacao === null) {
              const responseUltimaAtualizacao =
                await Municipio.getUltimaAtualizacao(response2.data.cod_ibge)

              if (responseUltimaAtualizacao) {
                this.$store.commit(
                  'setUltimaAtualizacao',
                  responseUltimaAtualizacao.data_sincronizacao
                    .split('-')
                    .reverse()
                    .join('/')
                )
                this.$store.commit('setSincronizadorC', {
                  ultimaAtualizacao:
                    responseUltimaAtualizacao.data_sincronizacao_c
                      .split('-')
                      .reverse()
                      .join('/'),
                  qtdDiasUltimaAtualizacao:
                    responseUltimaAtualizacao.qtd_dias_c,
                })
              }
            }

            // Microáreas do município
            const responseMicroareasMunicipio =
              await Municipio.getMicroAreasPorMunicipio(response2.data.cod_ibge)
            if (responseMicroareasMunicipio) {
              this.$store.commit('setMicroAreas', responseMicroareasMunicipio)
            }

            // Equipes V2 do município
            const responseEquipesV2 = await Municipio.getEquipesPorMunicipio(
              response2.data.cod_ibge
            )
            if (responseEquipesV2) {
              this.$store.commit('setEquipesV2', responseEquipesV2)
            }

            // armazena as informações do município
            let infoMunicipio = {
              exibe_logoefb: response2.data.infoMunicipio.exibe_logoefb,
              exibe_whatsapp: response2.data.infoMunicipio.exibe_whatsapp,
              logotipo: '',
              brasao: '',
            }

            if (infoMunicipio.exibe_logoefb == '1') {
              infoMunicipio.logotipo = require('@/assets/images/logo.png')
            } else {
              if (response2.data.infoMunicipio.logotipo != null) {
                infoMunicipio.logotipo =
                  this.$api.defaults.baseURL +
                  '/uploads/logotipos/' +
                  response2.data.infoMunicipio.logotipo
              }
            }

            // Define o brasão
            if (response2.data.infoMunicipio.brasao != null) {
              infoMunicipio.brasao =
                '/api/uploads/brasao/' + response2.data.infoMunicipio.brasao
            }

            this.$store.commit('setInfoMunicipio', infoMunicipio)

            this.$store.commit('setCodIbge', response2.data.cod_ibge)
            this.$store.commit('setIdFuncao', response2.data.id_funcao)
            this.$store.commit('setFuncao', response2.data.funcao)
            this.$store.commit('setUnidadeSaude', response2.data.unidade_saude)
            this.$store.commit('setId', response2.data.id)
            this.$store.commit('setUsername', response2.data.nome)
            this.$store.commit('setPermissoes', response2.data.permissoes)
            this.$store.commit(
              'setUltimaAtualizacaoCadastro',
              response2.data.ultima_atualizacao_cadastro
            )
            this.$store.commit('setRequiredPasswordUpdate', false)
            this.$store.commit('setPdf', response2.data.pdf)
            this.$store.commit('setCoDimProf', response2.data.co_dim_prof)

            // Se o usuário for o secretário, administrador ou gerente/coordenador, farmácia e outros avança direto para o dashboard, caso contrário
            // verifica se o usuário está na tabela de profissionais de saúde
            if (
              response2.data.id_funcao == 1 ||
              response2.data.id_funcao == 2 ||
              response2.data.id_funcao == 7 ||
              response2.data.id_funcao == 9 ||
              response2.data.id_funcao == 10 ||
              response2.data.id_funcao == 11 ||
              response2.data.id_funcao == 12 ||
              response2.data.id_funcao == 13 ||
              response2.data.id_funcao == 14 ||
              response2.data.id_funcao == 15
            ) {
              this.$router.push('/dashboard')
            } else {
              // verifica o profissional
              const profissional = await this.$api.post(
                '/app/profissional-saude',
                {
                  co_ibge: response2.data.cod_ibge,
                  cpf: this.funcao.cpf.replace(/[^\d]+/g, ''),
                }
              )

              if (profissional.data == false) {
                this.$store.dispatch('logout')
                this.$router.push('/acesso-negado')
              } else {
                this.$store.commit('setNuCns', response2.data.nu_cns)
                this.$store.commit('setNuIne', response2.data.nu_ine)
                this.$store.commit(
                  'setNuIneVinculada',
                  response2.data.nu_ine_vinculada
                )
                this.$store.commit('setNuCnes', response2.data.nu_cnes)
                this.$store.commit(
                  'setUnidadeSaude',
                  response2.data.unidade_saude
                )
                this.$store.commit('setMicroArea', response2.data.micro_area)

                // Se for Médico, enfermeiro ou odontólogo redireciona para a tela de escolher lotações
                if (
                  response2.data.id_funcao == 4 ||
                  response2.data.id_funcao == 8
                ) {
                  this.$router.push(
                    '/lotacoes/' +
                      response2.data.cod_ibge +
                      '/' +
                      this.funcao.cpf
                  )
                } else {
                  this.$router.push('/dashboard')
                }
              }
            }
            this.loading = false
            this.loadingBtn = false
          }
        }
        this.btnLoginDisable = false
      } catch (error) {
        this.btnLoginDisable = false
        console.log(error)
        switch (error.response.status) {
          case 500:
            this.$toast.error(
              'Erro',
              'Serviço temporariamente indisponível. Por favor, tente novamente mais tarde.',
              {
                position: 'topRight',
              }
            )
            break
          default:
            this.$toast.error(
              'Erro',
              'Serviço temporariamente indisponível. Por favor, tente novamente mais tarde.',
              {
                position: 'topRight',
              }
            )
            break
        }
      }
    },

    diferencaMaiorQue6Meses(dataComparacao) {
      if (dataComparacao == null) {
        return true
      }

      // Obtém a data atual
      const dataAtual = new Date()

      // Divide a data atual em dia, mês e ano
      const diaAtual = dataAtual.getDate()
      const mesAtual = dataAtual.getMonth() + 1 // Os meses em JavaScript são baseados em zero
      const anoAtual = dataAtual.getFullYear()

      // Divide a data de comparação em dia, mês e ano
      const partesData = dataComparacao.split('/')
      const diaComparacao = parseInt(partesData[0], 10)
      const mesComparacao = parseInt(partesData[1], 10)
      const anoComparacao = parseInt(partesData[2], 10)

      // Calcula a diferença em meses
      const diferencaMeses =
        (anoAtual - anoComparacao) * 12 + (mesAtual - mesComparacao)

      // Verifica se a diferença é maior do que 6 meses
      return diferencaMeses > 6
    },
  },
}
</script>

<style>
#login-parceiro {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

form {
  width: 100%;
}

.card-login {
  width: 400px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 1.25rem;
  position: relative;
  margin: 0px auto;
}

.card-icon i {
  font-size: 50px;
  line-height: 100px;
  text-align: center;
}

#login-parceiro .card-icon {
  position: relative;
  top: 0;
  height: 120px;
  width: 120px;
  border-radius: 50%;
  background: #f9f9f9;
  padding: 10px;
  text-align: center;
}

.card-title {
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  font-size: 17px;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 10px;
  text-align: center;
}

.btn-create-account {
  background-color: #0fafd7;
  border-color: #bf00dc;
  color: #fff;
  border-radius: 10rem;
  font-size: 0.838rem;
  font-weight: 500;
  padding: 0.55em 1.735em;
  line-height: 1.75em;
  width: 200px;
  display: inline-block;
  text-align: center;
  text-transform: uppercase;
  margin-right: 20px;
}

.card-login .btn {
  height: 40px;
  width: 120px;
  border-radius: 32px;
  display: inline-block;
  background-color: #0fafd7;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  margin-top: 10px;
}

@media screen and (max-width: 656px) {
}

@media screen and (min-width: 657px) and (max-width: 807px) {
}

@media screen and (min-width: 808px) and (max-width: 1023px) {
}

@media screen and (min-width: 1024px) and (max-width: 1265px) {
}

.links {
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
}

.links p {
  text-align: center;
  margin-bottom: 0;
  color: #000;
  font-size: 16px;
}

.links p a {
  margin: 0 auto;
}
</style>
